"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMemberRequest = exports.MemberUpdateRequest = exports.CleanMemberRequest = exports.MinimalMember = exports.CleanMember = exports.Member = exports.Oidc = exports.Email = exports.MemberId = exports.PII = exports.PhoneNumber = void 0;
const z = require("zod");
const Customer_1 = require("./Customer");
const UtilTypes_1 = require("./UtilTypes");
exports.PhoneNumber = z.string().refine(data => data.match(/^\+[0-9]+$/), { message: 'Data is not in format of phone number with country code' });
const IdNumber = z.string();
exports.PII = z.string();
exports.MemberId = UtilTypes_1.ObjectId;
const PhoneNumberHash = z.string();
const FirstName = z.preprocess(val => z.string().safeParse(val).success ? val.trim() : val, z.string());
const LastName = z.preprocess(val => z.string().safeParse(val).success ? val.trim() : val, z.string());
const BirthDate = z.preprocess(val => z.string().safeParse(val).success ? new Date(val) : val, z.date());
exports.Email = z.string();
const EmailHash = z.string();
exports.Oidc = z.object({
    sub: z.string(),
    email: exports.Email.optional(),
    emailPiiId: exports.PII.optional(),
    createdAt: z.string().optional(),
});
exports.Member = z.object({
    _id: exports.MemberId,
    firstName: FirstName,
    lastName: LastName,
    primary: z.boolean(),
    phoneNumber: exports.PhoneNumber,
    email: exports.Email.optional(),
    birthDate: BirthDate.optional(),
    idNumber: IdNumber.optional(),
    created: z.date(),
    customerId: Customer_1.CustomerId,
    saverId: UtilTypes_1.NumberString.optional(),
    enableMarketingEmails: z.boolean().optional(),
    emailValidated: z.boolean().optional(),
    firstNamePiiId: exports.PII.optional(),
    lastNamePiiId: exports.PII.optional(),
    phoneNumberPiiId: exports.PII.optional(),
    emailPiiId: exports.PII.optional(),
    birthDatePiiId: exports.PII.optional(),
    idNumberPiiId: exports.PII.optional(),
    phoneNumberHash: PhoneNumberHash.optional(),
    emailHash: EmailHash.optional(),
    oidc: exports.Oidc.optional(),
});
exports.CleanMember = exports.Member.omit({ phoneNumber: true, firstName: true, lastName: true, email: true, birthDate: true, idNumber: true });
exports.MinimalMember = exports.CleanMember.pick({ firstNamePiiId: true, customerId: true, _id: true })
    .extend({ hasOidc: z.boolean(), loginMethod: z.string().optional(), oidc: exports.Oidc.pick({ emailPiiId: true }) });
exports.CleanMemberRequest = exports.CleanMember.omit({ created: true, _id: true });
exports.MemberUpdateRequest = exports.Member.partial();
exports.CreateMemberRequest = exports.Member.omit({ _id: true, created: true, customerId: true });
//# sourceMappingURL=Member.js.map